import { render, staticRenderFns } from "./VerArea.vue?vue&type=template&id=911f4c28&"
import script from "./VerArea.vue?vue&type=script&lang=js&"
export * from "./VerArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports